<template lang="html">
  <app-modal
    @close="$emit('close')"
  >
    <app-modal-default @close="$emit('close')">
      <template v-slot:header>
        {{$ml.get(`Choose program type`)}}
      </template>
      <template v-slot:content>

        <div class="content">
          <div class="item">
            <button
              @click="createProgram('soil-based')"
              class="h-empty-btn h-btn"
            >
              <wheat-icon />
            </button>
            <div class="title">{{ $ml.get(`Soil based`) }}</div>
          </div>
          <div class="item">
            <button
              @click="createProgram('hydroponic')"
              class="h-empty-btn h-btn"
            >
              <sprinkler-icon />
            </button>
            <div class="title">{{ $ml.get(`Hydroponics`) }}</div>
          </div>
        </div>

      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import WheatIcon from '@/components/common/svg/WheatIcon'
import SprinklerIcon from '@/components/common/svg/SprinklerIcon'
import { mapGetters } from 'vuex';
import API from '@/api';

export default {
  data() {
    return {

    }
  },
  components: {
    WheatIcon,
    SprinklerIcon,
  },
  methods: {
    //=================================================================================
    createProgram(programType) {
      return API.program.addEmpty(programType).then(res => {
        let result = JSON.parse(JSON.stringify(res));
          if (result.data.message == "Please buy a plan!") {
            this.$notify({
              group: "notices",
              title: this.$ml.get(
                `Please buy a plan before creating programs.`
              ),
              type: "error",
            });
          } else {
            this.data = res.data.data;
            this.pageCount = res.data.pages;
          }
        this.$router.push(`/dashboard/programs/${res.data.data.id}`);
        this.$store.dispatch('user/availableReports');
      }).catch(err => {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(err.response.data.err),
          type : 'error',
        });
      });
    }
    //=================================================================================
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>

.content {
  display: flex;
  flex-direction: row;
  // align-items: center;
  justify-content: space-between;
  .item {
    margin: 10px;
    button {
      border-radius: 5px;
      border: 1px solid #4C5056;
      width: 160px;
      height: 140px;

      svg {
        fill: #4C5056;
      }

      &:hover {
        background-color: $mainGreen;
        border-color: $mainGreen;
        box-shadow: 0px 2px 12px rgba(73, 125, 56, 0.5);
        svg {
          fill: #fff;
        }
      }
    }
    .title {
      text-transform: uppercase;
      color: #4C5056;
      font-size: 12px;
      font-weight: bold;
      font-family: 'Roboto';
      padding: 12px 0;
      text-align: center;
      width: 100%;
    }
  }
  @media (max-width:768px) {
    flex-direction: column;
    .item {
      margin: 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      align-items: center;
      button {

      }
    }
  }
}

</style>
